<template>
  <div class = 'container' id = 'main_display' style = 'width: 100%'>
    <div v-show="!isLoading" class = 'container-fluid' style = 'height: 100%; position: relative;'>
      <div v-if="isTeacher" class = 'row' style = 'text-align: right;'>
        <AddModal :courseId="this.courseId"/>
        <button class = 'mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-js-ripple-effect mdl-button--colored' @click = 'startDelete'>
          <i class = 'material-icons'>remove</i>
          <span class = 'mdl-button__ripple-container'><span class = 'mdl-ripple'></span></span>
        </button>
      </div>
      <div v-if="weeks.length>0" id = 'week_container' style = 'padding: 30px 0;'>
        <WeekCell v-for="week in weeks" :key="week.id" :week="week"/>
      </div>
      <h4 v-else style="text-align: center;">沒有任務</h4>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<script>
import WeekCell from '@/components/Weeks/WeekCell.vue'
import AddModal from '@/components/Weeks/AddModal'
import Loading from '@/components/Utility/Loading.vue'
import $ from 'jquery'
var moment = require('moment')
export default {
  components: {
    Loading,
    WeekCell,
    AddModal
  },
  data () {
    return {
      isLoading: true,
      weeks: []
    }
  },
  computed: {
    isTeacher: function () {
      return this.role === 'teacher'
    },
    isStudent: function () {
      return this.role === 'student'
    },
    role: function () {
      return this.$parent.role
    },
    courseId: function () {
      return parseInt(this.$route.query.course)
    }
  },
  methods: {
    startDelete: function () {
      let isActive = $(this).prop('active')
      console.log($(this).prop('active'))
      if (!isActive) {
        $('.delete_icon').show()
      } else {
        $('.delete_icon').hide()
      }
      $(this).prop('active', !isActive)
    },
    addWeek: function (weekData) {
      this.weeks.push(weekData)
      this.sortWeek()
    },
    removeWeek: function (weekId) {
      let index = this.weeks.findIndex(week => week.id === weekId)
      this.weeks.splice(index, 1)
    },
    sortWeek: function () {
      this.weeks.sort((a, b) => {
        return moment(a.deadline, 'D MMM').isBefore(moment(b.deadline, 'D MMM')) ? 1 : -1
      })
    }
  },
  mounted: async function () {
    let weeks = await this.$store.dispatch('request', {
      route: `courses/${this.courseId}/weeks`
    })
    console.log(weeks)
    this.weeks = Object.values(weeks).map(w => {
      console.log(w.end_datetime)
      console.log(moment(w.end_datetime, 'MM/DD'))
      console.log(moment(w.end_datetime, 'MM/DD').format('D MMM'))
      return {
        id: w.id,
        title: w.title,
        description: w.description,
        noOfActivities: w.number_of_activities,
        deadline: moment(w.end_datetime, 'MM/DD').format('D MMM'),
        url: `courses/${this.courseId}/weeks/${w.id}`,
        files: w.files,
        mode: w.mode
      }
    })
    this.sortWeek()
    this.isLoading = false
  }
}
</script>
